import { render } from "./dialogDate.vue?vue&type=template&id=5bb64c28"
import script from "./dialogDate.vue?vue&type=script&lang=js"
export * from "./dialogDate.vue?vue&type=script&lang=js"

import "./dialogDate.vue?vue&type=style&index=0&id=5bb64c28&lang=css"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__